import gql from "graphql-tag";

export default gql`
  mutation updateRoomTemplateFile(
    $roomTemplateInput: RoomTemplateInputInput
    $customerId: ID
    $contractId: ID
    $roomTemplateId: ID
  ) {
    updateRoomTemplateFile(
      roomTemplateInput: $roomTemplateInput
      customerId: $customerId
      contractId: $contractId
      roomTemplateId: $roomTemplateId
    ) {
      id
      file
    }
  }
`;
